/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * User Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User schema for create
 * @export
 * @interface User
 */
export interface User {
    /**
     * @type {string}
     * @memberof User
     */
    username: string;
    /**
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * @type {string}
     * @memberof User
     */
    phone_number: string;
    /**
     * @type {string}
     * @memberof User
     */
    sub: string;
    /**
     * @type {string}
     * @memberof User
     */
    first_name: string;
    /**
     * @type {string}
     * @memberof User
     */
    last_name: string;
    /**
     * @type {string}
     * @memberof User
     */
    timezone: string;
    /**
     * @type {string}
     * @memberof User
     */
    role: UserRoleEnum;
    /**
     * @type {number}
     * @memberof User
     */
    id: number;
    /**
     * @type {number}
     * @memberof User
     */
    user_group: number;
    /**
     * @type {number}
     * @memberof User
     */
    permissions: number;
    /**
     * @type {Array<number>}
     * @memberof User
     */
    projects: Array<number>;
}

/**
 * @export
 * @enum {string}
 */
export enum UserRoleEnum {
    User = 'user',
    Admin = 'admin'
}

